import React, { useState } from "react"
import { useDropzone, FileWithPath } from "react-dropzone"
import { Stack, Typography } from "@mui/material"

export default function AdvertisementFileUpload({
  largeImage,
  setLargeImage,
  smallImage,
  setSmallImage,
  mobileImage,
  setMobileImage,
}: {
  largeImage: FileWithPath | undefined
  setLargeImage: React.Dispatch<React.SetStateAction<FileWithPath | undefined>>
  smallImage: FileWithPath | undefined
  setSmallImage: React.Dispatch<React.SetStateAction<FileWithPath | undefined>>
  mobileImage: FileWithPath | undefined
  setMobileImage: React.Dispatch<React.SetStateAction<FileWithPath | undefined>>
}) {
  const [largeImagePreview, setLargeImagePreview] = useState<string>("")
  const [smallImagePreview, setSmallImagePreview] = useState<string>("")
  const [mobileImagePreview, setMobileImagePreview] = useState<string>("")

  const onLargeDrop = (acceptedFiles: FileWithPath[]) => {
    setLargeImage(acceptedFiles[0])
    setLargeImagePreview(URL.createObjectURL(acceptedFiles[0]))
  }
  const onSmallDrop = (acceptedFiles: FileWithPath[]) => {
    setSmallImage(acceptedFiles[0])
    setSmallImagePreview(URL.createObjectURL(acceptedFiles[0]))
  }
  const onMobileDrop = (acceptedFiles: FileWithPath[]) => {
    setMobileImage(acceptedFiles[0])
    setMobileImagePreview(URL.createObjectURL(acceptedFiles[0]))
  }

  const { getRootProps: getLargeRootProps, getInputProps: getLargeInputProps } =
    useDropzone({
      accept: {
        "image/*": [],
      },

      onDrop: onLargeDrop,
      maxFiles: 1,
    })
  const { getRootProps: getSmallRootProps, getInputProps: getSmallInputProps } =
    useDropzone({
      accept: {
        "image/*": [],
      },

      onDrop: onSmallDrop,
      maxFiles: 1,
    })
  const {
    getRootProps: getMobileRootProps,
    getInputProps: getMobileInputProps,
  } = useDropzone({
    accept: {
      "image/*": [],
    },

    onDrop: onMobileDrop,
    maxFiles: 1,
  })

  const LargeImagePreviewComponent = () => {
    return (
      <div key={largeImage?.name}>
        <div>
          <img
            width={"100%"}
            height="120px"
            src={largeImagePreview}
            // onLoad={() => {
            //   URL.revokeObjectURL(largeImagePreview)
            // }}
          />
        </div>
      </div>
    )
  }
  const SmallImagePreviewComponent = () => {
    return (
      <div key={smallImage?.name}>
        <div>
          <img
            width={"100%"}
            height="120px"
            src={smallImagePreview}
            // onLoad={() => {
            //   URL.revokeObjectURL(smallImagePreview)
            // }}
          />
        </div>
      </div>
    )
  }
  const MobileImagePreviewComponent = () => {
    return (
      <div key={mobileImage?.name}>
        <div>
          <img
            width={"100%"}
            height="120px"
            src={mobileImagePreview}
            // onLoad={() => {
            //   URL.revokeObjectURL(mobileImagePreview)
            // }}
          />
        </div>
      </div>
    )
  }

  //   useEffect(() => {
  //     URL.revokeObjectURL(largeImagePreview)
  //     URL.revokeObjectURL(smallImagePreview)
  //     URL.revokeObjectURL(mobileImagePreview)
  //   }, [largeImagePreview, smallImagePreview, mobileImagePreview])

  return (
    <section>
      <h4>Files</h4>
      <Stack direction="column" width="100%" spacing={2}>
        <Typography variant="h4">Large</Typography>
        <Stack width="100%" direction="row" justifyContent="space-between">
          <div
            {...getLargeRootProps()}
            style={{
              border: "2px dashed #000",
              padding: "20px",
              cursor: "pointer",
              maxWidth: "30%",
              maxHeight: "120px",
            }}
          >
            <input {...getLargeInputProps()} />
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>
          {largeImage?.name && <LargeImagePreviewComponent />}
        </Stack>
        <Typography variant="h4">Small</Typography>
        <Stack width="100%" direction="row" justifyContent="space-between">
          <div
            {...getSmallRootProps()}
            style={{
              border: "2px dashed #000",
              padding: "20px",
              cursor: "pointer",
              maxWidth: "30%",
              maxHeight: "120px",
            }}
          >
            <input {...getSmallInputProps()} />
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>
          {smallImage?.name && <SmallImagePreviewComponent />}
        </Stack>
        <Typography variant="h4">Mobile</Typography>
        <Stack width="100%" direction="row" justifyContent="space-between">
          <div
            {...getMobileRootProps()}
            style={{
              border: "2px dashed #000",
              padding: "20px",
              cursor: "pointer",
              maxWidth: "30%",
              maxHeight: "120px",
            }}
          >
            <input {...getMobileInputProps()} />
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>
          {mobileImage?.name && <MobileImagePreviewComponent />}
        </Stack>
      </Stack>
    </section>
  )
}
